import React, { useEffect } from 'react';
import './_whatsNew.scss';
import { useCombined } from '../../../common/base/CombinedContext';

const WhatsNew = () => {
    const { setBreadcrumbItems } = useCombined()
    useEffect(() => {
        const breadcrumbItems = [
            { title: "Cisco IT APIs", url: "/" },
            { title: "What's New", url: "" }
        ];

        setBreadcrumbItems(breadcrumbItems);
    }, [setBreadcrumbItems]);
    return (
        <div id="pubhub-widgets" className="pubhub-site-container">
            <div className="features-header mb-5">
                <div className='header-title'>What’s New on Cisco IT API Portal</div>
                <div className='header-description'>Learn all about the changes happening to the IT API Portal! <br />From new features that have recently launched, to features that are on their way. </div>
            </div>

            <div className="features-content container">
                <div className="section">
                    <h5>Active features:</h5>
                    <ul>
                        <li>
                            <strong>Request Access:</strong>
                            <ul>
                                <li>Users are able to request access for the API.</li>
                                <li>Based on the selected SLA Tier there are two approval options:</li>
                                <ul>
                                    <li><em>Auto approval</em> - request will be automatically approved.</li>
                                    <li><em>Manual approval</em> - request will be sent to the publisher.</li>
                                </ul>
                            </ul>
                        </li>
                        <li>
                            <strong>Create application:</strong>
                            <ul>
                                <li>Users are able to create a new application.</li>
                            </ul>
                        </li>
                        <li>
                            <strong>My Apps:</strong>
                            <ul>
                                <li>Users can copy Client ID and Client Secret.</li>
                                <li>Users are able to access a list of applications.</li>
                                <li>Users can search their applications by the application name.</li>
                                <li><em>Update application</em> - Users can make updates to the app details such as name, description, application URLs, etc.</li>
                                <li><em>Delete application</em> - Users have the ability to delete applications.</li>
                                <li><em>Reset Client Secret</em> - Users are able to generate a new Client Secret. New credentials are displayed after the successful reset.</li>
                            </ul>
                        </li>
                        <li>
                            <strong>Notification Icon:</strong>
                            <ul>
                                <li>The notification icon in the header will be highlighted if there are any pending requests. Clicking on that icon will redirect Publisher to the Request Management page where Publisher can approve, deny or remove the requests.</li>
                            </ul>
                        </li>
                        <li>
                            <strong>Request Management:</strong>
                            <ul>
                                <li>Publisher can view all the requests for API access.</li>
                                <li>Publisher can search the requests by the API name.</li>
                                <li>Publisher can filter the requests by the status.</li>
                                <li>Publisher can approve or deny the pending requests.</li>
                                <li>Publisher can deny the approved requests.</li>
                                <li>Publisher can remove the requests.</li>
                            </ul>
                        </li>
                        <li>
                            <strong>API Testing</strong>
                            <ul>
                                <li>Users are able to test their API with multiple security schemes (e.g. Client Credentials, Password Grant, Implicit Grant).</li>
                            </ul>
                        </li>
                    </ul>
                </div>

                <div className="section">
                    <h5>Features coming soon:</h5>
                    <ul>
                        <li>
                            <strong>Test API:</strong>
                            <ul>
                                <li>Testing API with Authorization Code with PKCE</li>
                                <ul>
                                    <li>Users will be able to test their API with Authorization Code with PKCE.</li>
                                </ul>
                                {/* <li>XML support</li>
                                <ul>
                                    <li>User will be able to test the API with both JSON and XML payloads/responses.</li>
                                </ul> */}
                            </ul>
                        </li>
                        <li>
                            <strong>Notifications:</strong>
                            <ul>
                                <li>Publisher will be able to see a dropdown with a list of all pending requests.</li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <div className="section">
                    <h5>Known Issues:</h5>
                    <ul>
                        <li>
                            Testing the API with Authorization Code with PKCE is currently not possible.
                        </li>
                        <li>
                            Updating Grant Types and Redirect URI for Clients is blocked due to an issue at the Mulesoft end.
                        </li>
                        <li>
                            Creating a client with Resource Owner Grant with Refresh Token fails.
                        </li>
                        <li>
                            Creating a client with Implicit Grant and Redirect URI fails.
                        </li>
                        <li>
                            Error messages across the portal need improvement to be clearer and more informative.
                        </li>
                        <li>
                            Deprecate API version is not supported.
                        </li>
                        <li>
                            Performance issues in My Apps and Request Management pages due to Mulesoft data loading.
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default WhatsNew;
